/** Parse a one-based document page from a route query parameter. */
export function parsePositivePageNumber(value: string | null): number | undefined {
  if (value === null || !/^\d+$/.test(value)) return undefined
  const page = Number(value)
  return Number.isSafeInteger(page) && page > 0 ? page : undefined
}

/** Add native browser PDF page navigation to an object URL. */
export function pdfPreviewHref(objectUrl: string, pageNumber?: number): string {
  return Number.isInteger(pageNumber) && (pageNumber ?? 0) > 0
    ? `${objectUrl}#page=${pageNumber}`
    : objectUrl
}
